<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!-- ONT发现列表 -->
        <block-cntr :btitle="'ONT Find List'" style="height: 410px">
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="loadOntFindList()"
                  class="btn"
                  :class="{}"
                  style="padding: 0px"
                >
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
            <span style="margin-left: 25px; font-weight: bold"
              >Total entries: {{ total }}</span
            >
            <label style="float: right; display: flex">
              <span class="input-group-addon tablesearch-box">
                <i class="fa fa-search"></i>
              </span>
              <input
                type="search"
                v-model="searchInfo"
                class="form-control"
                placeholder="slot/pon"
                style="border-radius: 0px"
              />
            </label>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in ontFindList.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
                <th>
                  Config Rule
                </th>
              </tr>
            </thead>
            <tbody style="height: 350px">
              <tr v-for="(row, index) in ontFindInfoFilter" :key="index">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  <div
                    v-if="key == 'detail'"
                    @click="getfindListInfo(row.port, row.index)"
                    class="btn"
                    :class="{ disabled: false }"
                    style="padding: 0px"
                  >
                    <i class="fa fa-external-link page-tableaction"></i>
                  </div>
                  <div v-else>{{ value }}</div>
                </td>
                <td>
                  <div
                    @click="SetOntRuleProfile(row)"
                    class="btn"
                    :class="{ disabled: false }"
                    style="padding: 0px"
                  >
                    <i class="fa fa-edit page-tableaction"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      ontFindList: "",
      searchInfo: "",
      total: "",
      OntFindInfo:"",
    }
  },
  created() {
    this.loadOntFindList()
  },
  methods: {
    loadOntFindList() {
      get("ontFindList")
        .then((res) => {
          console.log(res)
          this.ontFindList = res.data
        })
        .catch((err) => {
          this.ontFindList = en.findList
        })
    },

    getfindListInfo(port, index) {
      this.$router.push({
        path: "/gponfindont",
        name: "gponFindOnt",
        query: { port: port, index: index },
      })
    },

    SetOntRuleProfile(row){
      var snFormat = 0
      var pwFormat = 0
      var sn = row.sn

      get("ontFindInfo?port=" + row.port + "&index=" + row.index)
        .then((res) => {
             this.OntFindInfo = res.data
             if(this.OntFindInfo.password.v.match(/^0x/) != null){
                this.OntFindInfo.password.v = this.OntFindInfo.password.v.replace('0x', '')
                pwFormat = 1
              }
              if(row.sn.match(/^0x/) != null)
              {
                sn = row.sn.replace('0x', '')
                snFormat = 1
              }

              this.$router.push({
                path: "/profilerule",
                query: { sn: sn, edit: true, authmode: '0', pw: this.OntFindInfo.password.v,
                        loid: this.OntFindInfo.loid.v, loidpw: this.OntFindInfo.loidPwd.v, port: row.port,
                        snFormat: snFormat, pwFormat: pwFormat },
              })
         })
        .catch((err) => {})
      }
   },
  computed: {
    ontFindInfoFilter() {
      var findInfo = []
      this.total = 0
      if (this.ontFindList.data !== undefined)
        this.ontFindList.data.forEach((element) => {
          if (
            this.searchInfo == "" ||
            this.searchInfo == element.port.replace("g", "")
          ) {
            findInfo.push(element)
            this.total += 1
          }
        })
      return findInfo
    },
  },
}
</script>